module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Senior-05Merit_Prize_S06.c8a4b7ec.png";